export enum DataMethods {
  /// <summary>
  /// None DataMethods enum.
  /// </summary>
  ConfigData = 1,
  /// <summary>
  /// GetSnapshot DataMethods enum.
  /// </summary>
  Snapshot = 2,
  /// <summary>
  /// RecordedValue DataMethods enum.
  /// </summary>
  RecordedValue = 4,
  /// <summary>
  /// RecordedValues DataMethods enum.
  /// </summary>
  RecordedValues = 8,
  /// <summary>
  /// RecordedValuesByCount DataMethods enum.
  /// </summary>
  RecordedValuesByCount = 16,
  /// <summary>
  /// PlotValues DataMethods enum.
  /// </summary>
  PlotValues = 32,
  /// <summary>
  /// InterpolatedValue DataMethods enum.
  /// </summary>
  InterpolatedValue = 64,
  /// <summary>
  /// InterpolatedValues DataMethods enum.
  /// </summary>
  InterpolatedValues = 128,
  /// <summary>
  /// InterpolatedValuesByCount DataMethods enum.
  /// </summary>
  InterpolatedValuesByCount = 256,
  /// <summary>
  /// InterpolatedValuesAtTimes DataMethods enum.
  /// </summary>
  //   InterpolatedValuesAtTimes = 512,
  /// <summary>
  /// SetValues DataMethods enum.
  /// </summary>
  SetValues = 1024,
  /// <summary>
  //   /// Previuos value DataMethods enum
  //   /// </summary>
  PreviousValue = 2048

  /// <summary>
  /// PERSISTENTWRITE DataMethods enum.
  /// </summary>
  // PERSISTENTWRITE = 4
}
